
(function () {
  function debounce(func, wait) {
    let timeout;
    return function () {
      const context = this,
        args = arguments;
      clearTimeout(timeout);
      timeout = setTimeout(function () {
        func.apply(context, args);
      }, wait);
    };
  }

  // Function to check screen size and initialize the slider accordingly
  function checkScreenSizeAndInitSwipers() {
    const width = window.innerWidth;
    const isDesktop = width >= 1480;
    const islaptop = width >= 1025;
    const isTablet = width <= 1024;
    //const isMobile = width <= 991;
    // Initialize Swipers only for the relevant screen sizes
    document.querySelectorAll('.swiper-container').forEach(container => {
      const uniqueId = container.getAttribute('data-id');
      const arrowsEnabled = container.getAttribute('data-arrows-enabled') === 'true';
      const autoplayEnabled = container.getAttribute('data-autoplay-enabled') === 'true';
      const autoplayDelay = parseInt(container.getAttribute('data-autoplay-delay'), 10) || 3000;
      const loopEnabled = container.getAttribute('data-loop-enabled') === 'true';
      const dotsEnabled = container.getAttribute('data-dots-enabled') === 'true';

      // Check if slider is enabled for the current device type
      const isSliderEnabled = (islaptop && container.getAttribute('data-desktop-slider') === 'true') ||
                              (isTablet && container.getAttribute('data-tablet-slider') === 'true') ||
                              (isTablet && container.getAttribute('data-mobile-slider') === 'true');

      if (!isSliderEnabled) {
        return; // Skip initialization if slider is not enabled for this device
      }

      let slidesPerView, spaceBetween;



      // Destroy existing Swiper instance if it exists
      if (container.swiper) {
        container.swiper.destroy(true, true);
        delete container.swiper; // Clear the reference
      }

      // Initialize Swiper with dynamic parameters
      const swiperContainer = document.getElementById(`swiper-${uniqueId}`);
      if (swiperContainer) {
        container.swiper = new Swiper(swiperContainer, {
          slidesPerView: slidesPerView,
          spaceBetween: spaceBetween,
          loop: loopEnabled,
          autoplay: autoplayEnabled ? { delay: autoplayDelay } : false,
          roundLengths: true,

          navigation: arrowsEnabled ? {
            nextEl: `#swiper-${uniqueId} .swiper-button-next`,
            prevEl: `#swiper-${uniqueId} .swiper-button-prev`,
          } : false,
          pagination: dotsEnabled ? {
            el: `#swiper-${uniqueId} .swiper-pagination`,
            clickable: true,
          } : false,
          breakpoints: {
            // Optional: use breakpoints to manage slides per view
            0: {
              slidesPerView: parseFloat(container.getAttribute('data-slides-per-view-mobile')) || 1,
              spaceBetween: parseInt(container.getAttribute('data-space-between-mobile'), 10) || 0,
            },
           
            680: {
              slidesPerView: parseFloat(container.getAttribute('data-slides-per-view-medium-tablet')) || 1,
              spaceBetween: parseInt(container.getAttribute('data-space-between-medium-tablet'), 10) || 0,
            },
          
             880: {
              slidesPerView: parseFloat(container.getAttribute('data-slides-per-view-tablet')) || 1,
              spaceBetween: parseInt(container.getAttribute('data-space-between-tablet'), 10) || 0,
            },

            1280: {
                slidesPerView: parseFloat(container.getAttribute('data-slides-per-view-laptop')) || 1,
              spaceBetween: parseInt(container.getAttribute('data-space-between-laptop'), 10) || 0,
            },

            1680: {
              slidesPerView: parseFloat(container.getAttribute('data-slides-per-view-desktop')) || 1,
              spaceBetween: parseInt(container.getAttribute('data-space-between-desktop'), 10) || 0,
            }
          },
        });
      } else {
        console.error(`Element with ID swiper-${uniqueId} not found`);
      }
    });
  }
 

  // Wrap the initialization function with debounce
  const debouncedCheckScreenSizeAndInitSwipers = debounce(checkScreenSizeAndInitSwipers, 300);
  // Add event listeners for window resize and Shopify section events
  //window.addEventListener('resize', debouncedCheckScreenSizeAndInitSwipers);
  document.addEventListener('shopify:section:load', debouncedCheckScreenSizeAndInitSwipers);
  document.addEventListener('shopify:section:select', debouncedCheckScreenSizeAndInitSwipers);
  document.addEventListener('shopify:section:deselect', debouncedCheckScreenSizeAndInitSwipers);
  document.addEventListener('shopify:section:reorder', debouncedCheckScreenSizeAndInitSwipers);

  // Initial call to set up sliders after DOM is fully loaded
  document.addEventListener('DOMContentLoaded', checkScreenSizeAndInitSwipers);
})();
